/**
 * Translation maps for DB values.
 * Returns correct label based on current language.
 */

const PHASE_LABELS = {
  nb: { setup: 'Oppsett', planning: 'Planlegging', implementation: 'Gjennomføring', review: 'Evaluering', maintenance: 'Vedlikehold', operations: 'Drift' },
  en: { setup: 'Setup', planning: 'Planning', implementation: 'Implementation', review: 'Review', maintenance: 'Maintenance', operations: 'Operations' },
};

const SOURCE_LABELS = {
  nb: { ik_flow: 'Internkontroll', iso_flow: 'ISO', mf_flow: 'Miljøfyrtårn', manual: 'Manuell', risk: 'Risiko' },
  en: { ik_flow: 'Internal Control', iso_flow: 'ISO', mf_flow: 'Miljøfyrtårn', manual: 'Manual', risk: 'Risk' },
};

const SEVERITY_LABELS = {
  nb: { low: 'Lav', medium: 'Middels', high: 'Høy', critical: 'Kritisk' },
  en: { low: 'Low', medium: 'Medium', high: 'High', critical: 'Critical' },
};

const STATUS_LABELS = {
  nb: { open: 'Åpen', closed: 'Lukket', in_progress: 'Under arbeid', not_started: 'Ikke startet', completed: 'Fullført' },
  en: { open: 'Open', closed: 'Closed', in_progress: 'In Progress', not_started: 'Not Started', completed: 'Completed' },
};

function getLang(lang) {
  if (lang) return lang.startsWith('en') ? 'en' : 'nb';
  try {
    const stored = localStorage.getItem('i18nextLng') || 'nb';
    return stored.startsWith('en') ? 'en' : 'nb';
  } catch {
    return 'nb';
  }
}

export function translatePhase(phase, lang) {
  const l = getLang(lang);
  return (PHASE_LABELS[l] || PHASE_LABELS.nb)[phase] || phase;
}

export function translateSource(source, lang) {
  const l = getLang(lang);
  return (SOURCE_LABELS[l] || SOURCE_LABELS.nb)[source] || source;
}

export function translateSeverity(severity, lang) {
  const l = getLang(lang);
  return (SEVERITY_LABELS[l] || SEVERITY_LABELS.nb)[severity] || severity;
}

export function translateStatus(status, lang) {
  const l = getLang(lang);
  return (STATUS_LABELS[l] || STATUS_LABELS.nb)[status] || status;
}
